"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pharmacy = void 0;
const mobx_1 = require("mobx");
const locations_1 = require("./locations");
/**
 * Page 7
 * -  Pharmacy label Cali
 */
class Pharmacy {
    constructor(printMeta, lastPage) {
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            const { claim } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const { order } = currentClaim;
            const { site } = order;
            const siteLocation = site.state;
            switch (siteLocation) {
                case "CA":
                    return new locations_1.PharmacyMakeCali(this.printMeta, this.lastPage).make();
                default:
                    return new locations_1.PharmacyMakeDefault(this.printMeta, this.lastPage).make();
            }
        };
    }
}
exports.Pharmacy = Pharmacy;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/pharmacy/pharmacy.ts
// module id = 2740
// module chunks = 0 1